/**
 * Action
 */
enum NetworkAction {
  DELEGATION = 'Delegation',
  REWARD = 'Reward',
  UNDELEGATION = 'UnDelegation',
  COMBINE = 'Combine',
}
export { NetworkAction };
